import isEmpty from 'lodash/isEmpty';

function calcProgress (user, content) {
  if (isEmpty(user)) {
    return null;
  }
  const {
    progress,
    completedCount
  } = user;
  const {
    unitCount
  } = content;
  let calculatedProgress = 0;
  if (typeof progress !== "undefined") {
    calculatedProgress = progress;
  } else if (unitCount > 0) {
    calculatedProgress = Math.round(parseInt(completedCount, 10) / parseInt(unitCount, 10) * 100);
  }
  calculatedProgress = calculatedProgress > 100 ? 100 : calculatedProgress;
  return calculatedProgress;
}

export { calcProgress as default };
